import styled from "styled-components";

// tslint:disable-next-line
export const SpecialActionWrapper = styled.div`
  position: relative;
`;
